// src/utils/validation.js

import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Müşterinin silinip silinemeyeceğini kontrol eder
 * @param {string} customerId - Müşteri ID
 * @returns {Promise<{canDelete: boolean, reason: string, counts: object}>}
 */
export const canDeleteCustomer = async (customerId) => {
    try {
        // Müşteriye ait cihazları kontrol et
        const devicesQuery = query(
            collection(db, 'devices'),
            where('musteriId', '==', customerId)
        );
        const devicesSnapshot = await getDocs(devicesQuery);
        const deviceCount = devicesSnapshot.size;

        // Müşteriye ait servis kayıtlarını kontrol et
        const servicesQuery = query(
            collection(db, 'serviceRecords'),
            where('musteriId', '==', customerId)
        );
        const servicesSnapshot = await getDocs(servicesQuery);
        const serviceCount = servicesSnapshot.size;

        const canDelete = deviceCount === 0 && serviceCount === 0;

        let reason = '';
        if (!canDelete) {
            reason = `Bu müşteriye ait ${deviceCount} cihaz ve ${serviceCount} servis kaydı bulunmaktadır. Önce bunları silmeniz gerekmektedir.`;
        }

        return {
            canDelete,
            reason,
            counts: {
                devices: deviceCount,
                services: serviceCount
            }
        };
    } catch (error) {
        console.error('Müşteri silme kontrolü sırasında hata:', error);
        return {
            canDelete: false,
            reason: 'Kontrol sırasında bir hata oluştu. Lütfen tekrar deneyin.',
            counts: { devices: 0, services: 0 }
        };
    }
};

/**
 * Cihazın silinip silinemeyeceğini kontrol eder
 * @param {string} deviceId - Cihaz ID
 * @returns {Promise<{canDelete: boolean, reason: string, count: number}>}
 */
export const canDeleteDevice = async (deviceId) => {
    try {
        // Cihaza ait servis kayıtlarını kontrol et
        const servicesQuery = query(
            collection(db, 'serviceRecords'),
            where('cihazId', '==', deviceId)
        );
        const servicesSnapshot = await getDocs(servicesQuery);
        const serviceCount = servicesSnapshot.size;

        const canDelete = serviceCount === 0;

        let reason = '';
        if (!canDelete) {
            reason = `Bu cihaza ait ${serviceCount} servis kaydı bulunmaktadır. Önce bunları silmeniz gerekmektedir.`;
        }

        return {
            canDelete,
            reason,
            count: serviceCount
        };
    } catch (error) {
        console.error('Cihaz silme kontrolü sırasında hata:', error);
        return {
            canDelete: false,
            reason: 'Kontrol sırasında bir hata oluştu. Lütfen tekrar deneyin.',
            count: 0
        };
    }
};
